module.exports = __webpack_public_path__ + "static/media/ws-lock.d994c131.svg";